module.exports = __webpack_public_path__ + "img/brands-barilla-bio-sauce.jpg?2cbdac98f9fcfd37c75b2ad1dcfbf313";